import React from 'react';
import CardModal from '../CardModal';

export const AGE_VERIFICATION_MODAL = 'ageVerificationModal';
const AgeVerificationModal = () => {
// eslint-disable-next-line no-undef
    const [showAgeVerificationModal, setShowAgeVerificationModal] = React.useState(localStorage.getItem(AGE_VERIFICATION_MODAL) !== 'true');

    return (
        <CardModal
            title="CBD Legality"
            showClose={false}
            actions={(
                <>
                    <button
                        className="button is-success"
                        type="button"
                        onClick={() => {
                            // eslint-disable-next-line no-undef
                            localStorage.setItem(AGE_VERIFICATION_MODAL, 'true');
                            setShowAgeVerificationModal(false);
                        }}
                    >
                        Yes
                    </button>
                    <button
                        className="button"
                        type="button"
                        onClick={() => {
                            // eslint-disable-next-line no-undef
                            localStorage.setItem(AGE_VERIFICATION_MODAL, 'false');
                            // eslint-disable-next-line no-undef,no-restricted-globals
                            location.replace('/under-age');
                        }}
                    >
                        No
                    </button>
                </>
            )}
            show={showAgeVerificationModal}
        >
            Are you 18+ years of age?
        </CardModal>
    );
};

export default AgeVerificationModal;
